import * as i0 from '@angular/core';
import { Injectable, NgModule, Inject, PLATFORM_ID, InjectionToken, APP_INITIALIZER, Optional, EventEmitter, Directive, ViewContainerRef, Component, ViewEncapsulation, ComponentFactoryResolver, ChangeDetectorRef, ViewChild, ApplicationRef, Injector, ElementRef, Input, Renderer2, HostListener, NgZone, TemplateRef } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpParams, HttpClient, HttpClientModule, HTTP_INTERCEPTORS, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import * as i6 from '@angular/common';
import { isPlatformBrowser, CommonModule, DOCUMENT } from '@angular/common';
import { catchError, tap, filter, first, map, take } from 'rxjs/operators';
import { Observable, Subject, fromEvent, BehaviorSubject } from 'rxjs';
import * as i1$1 from '@angular/router';
import { NavigationEnd, Router, ActivationEnd, DefaultUrlSerializer, NavigationCancel, NavigationStart, ActivatedRoute } from '@angular/router';
import * as i4 from '@angular/platform-browser';
import { makeStateKey, TransferState, Title, Meta } from '@angular/platform-browser';
import * as i3 from '@nguniversal/express-engine/tokens';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { v4 } from 'uuid';
import { __awaiter as __awaiter$1 } from 'tslib';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@angular/platform-browser';
import * as ɵngcc4 from '@angular/common';

function MaxDialogComponent_ng_template_4_Template(rf, ctx) { }
const _c0 = function (a0) { return { "show": a0 }; };
function isNullOrUndefined(arg) {
    return arg == null;
}

class HttpService {
    // tslint:disable-next-line:max-line-length
    constructor(http$) {
        this.http$ = http$;
    }
    get(url, httpParams, options) {
        httpParams = this.getParams(options, httpParams);
        return this.http$.get(url, { params: httpParams });
    }
    getLower(url, httpParams, options) {
        httpParams = this.getParams(options, httpParams);
        return this.http$.get(url, { params: httpParams });
    }
    post(url, body, options) {
        const params = this.getParams(options);
        return this.http$.post(url, body, { params });
    }
    postLower(url, body, options) {
        const params = this.getParams(options);
        return this.http$.post(url, body, { params });
    }
    put(url, body, options) {
        const params = this.getParams(options);
        return this.http$.post(url, body, { params });
    }
    delete(url, options) {
        const params = this.getParams(options);
        return this.http$.delete(url, { params });
    }
    multipart(url, formData, httpParams, options) {
        httpParams = this.getParams(options, httpParams);
        return this.http$.post(url, formData, { params: httpParams });
    }
    /**
    * @deprecated Since moveing to new node/nestjs.
    */
    getWithSsrCache(url, cacheKey, httpParams, options) {
        httpParams = this.getParams(options, httpParams);
        return this.get(url, httpParams);
    }
    /**
    * @deprecated Since moveing to new node/nestjs.
    */
    getLowerWithSsrCache(url, cacheKey, httpParams, options) {
        httpParams = this.getParams(options, httpParams);
        return this.getLower(url, httpParams);
    }
    getParams(options, httpParams) {
        if (!httpParams) {
            httpParams = new HttpParams();
        }
        httpParams = httpParams.append('interceptorUseToken', 'use');
        if (options && options.tokenGroup) {
            httpParams = httpParams.append('tokenGroup', options.tokenGroup);
        }
        if (options && (!isNullOrUndefined(options.disableDefaultSpinnerBehavior)
            || !isNullOrUndefined(options.defaultApiFailureBehavior))) {
            if (!isNullOrUndefined(options.disableDefaultSpinnerBehavior)) {
                httpParams = httpParams.append('disableDefaultSpinnerBehavior', options.disableDefaultSpinnerBehavior.toString());
            }
            if (!isNullOrUndefined(options.defaultApiFailureBehavior)) {
                httpParams = httpParams.append('defaultApiFailureBehavior', options.defaultApiFailureBehavior.toString());
            }
        }
        return httpParams || null;
    }
}
HttpService.ɵfac = function HttpService_Factory(t) { return new (t || HttpService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
HttpService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HttpService_Factory() { return new HttpService(i0.ɵɵinject(i1.HttpClient)); }, token: HttpService, providedIn: "root" });
HttpService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HttpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class HttpModule {
    static forRoot() {
        return {
            ngModule: HttpModule,
            providers: []
        };
    }
}
HttpModule.ɵfac = function HttpModule_Factory(t) { return new (t || HttpModule)(); };
HttpModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HttpModule });
HttpModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        HttpService
    ], imports: [[
            HttpClientModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HttpModule, [{
        type: NgModule,
        args: [{
                imports: [
                    HttpClientModule
                ],
                declarations: [],
                providers: [
                    HttpService
                ],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HttpModule, { imports: function () { return [HttpClientModule]; } }); })();

class UiHelperService {
    constructor(platformId) {
        this.platformId = platformId;
        this.isBrowser = isPlatformBrowser(platformId);
    }
    detectIE() {
        if (!this.isBrowser) {
            return false;
        }
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
        const trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            const rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
        const edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }
        // other browser
        return false;
    }
}
UiHelperService.ɵfac = function UiHelperService_Factory(t) { return new (t || UiHelperService)(ɵngcc0.ɵɵinject(PLATFORM_ID)); };
UiHelperService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: UiHelperService, factory: UiHelperService.ɵfac });
UiHelperService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiHelperService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();

class UiHelperModule {
    static forRoot() {
        return {
            ngModule: UiHelperModule,
            providers: [
                UiHelperService
            ]
        };
    }
}
UiHelperModule.ɵfac = function UiHelperModule_Factory(t) { return new (t || UiHelperModule)(); };
UiHelperModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UiHelperModule });
UiHelperModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiHelperModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [],
                providers: [],
                exports: []
            }]
    }], null, null); })();

const CONFIG_URL = new InjectionToken("configUrl");

class ServerConfigurationService {
    // tslint:disable-next-line:max-line-length
    constructor(httpSvc, platformId, configUrl) {
        this.httpSvc = httpSvc;
        this.platformId = platformId;
        this.configUrl = configUrl;
        this.isBrowser = isPlatformBrowser(platformId);
    }
    load() {
        return this.httpSvc
            .get(this.configUrl)
            .pipe(catchError((error) => {
            console.log(`Configuration file "${this.configUrl.substring(this.configUrl.lastIndexOf('/') + 1)}" could not be read`);
            return Observable.throw(error || 'Server error');
        }))
            .toPromise()
            .then(res => {
            this._appConfigs = res;
            if (!this.isBrowser) {
                try {
                    //replace https to http only in server.
                    this._appConfigs.apiUrl = this._appConfigs.apiUrl.replace('https', 'http');
                }
                catch (error) {
                    console.log('error in ServerConfigurationService: ' +
                        error.toString());
                }
            }
        });
    }
    getAppConfigs() {
        return this._appConfigs;
    }
}
ServerConfigurationService.ɵfac = function ServerConfigurationService_Factory(t) { return new (t || ServerConfigurationService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(CONFIG_URL)); };
ServerConfigurationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ServerConfigurationService, factory: ServerConfigurationService.ɵfac });
ServerConfigurationService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: String, decorators: [{ type: Inject, args: [CONFIG_URL,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServerConfigurationService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [CONFIG_URL]
            }] }]; }, null); })();

function init_app$1(serverConfigurationService) {
    const initAppFunction = () => { return serverConfigurationService.load(); };
    return initAppFunction;
}
class ServerConfigurationModule {
    static forRoot(configUrl) {
        return {
            ngModule: ServerConfigurationModule,
            providers: [
                {
                    provide: CONFIG_URL,
                    useValue: configUrl
                }
            ]
        };
    }
}
ServerConfigurationModule.ɵfac = function ServerConfigurationModule_Factory(t) { return new (t || ServerConfigurationModule)(); };
ServerConfigurationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ServerConfigurationModule });
ServerConfigurationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        ServerConfigurationService,
        {
            provide: APP_INITIALIZER,
            useFactory: init_app$1,
            deps: [ServerConfigurationService],
            multi: true
        }
    ], imports: [[
            HttpModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServerConfigurationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    HttpModule
                ],
                declarations: [],
                providers: [
                    ServerConfigurationService,
                    {
                        provide: APP_INITIALIZER,
                        useFactory: init_app$1,
                        deps: [ServerConfigurationService],
                        multi: true
                    }
                ],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ServerConfigurationModule, { imports: [HttpModule] }); })();

class UniversalInterceptorService {
    constructor(serverUrl) {
        this.serverUrl = serverUrl;
    }
    intercept(req, next) {
        if (req.url.indexOf('http://') === 0 || req.url.indexOf('https://') === 0) {
            return next.handle(req);
        }
        const serverReq = !this.serverUrl
            ? req
            : req.clone({
                url: `${this.serverUrl}${req.url}`
            });
        return next.handle(serverReq);
    }
}
UniversalInterceptorService.ɵfac = function UniversalInterceptorService_Factory(t) { return new (t || UniversalInterceptorService)(ɵngcc0.ɵɵinject('serverUrl', 8)); };
UniversalInterceptorService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: UniversalInterceptorService, factory: UniversalInterceptorService.ɵfac });
UniversalInterceptorService.ctorParameters = () => [
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: ['serverUrl',] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UniversalInterceptorService, [{
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: ['serverUrl']
            }] }]; }, null); })();

class UniversalModule {
}
UniversalModule.ɵfac = function UniversalModule_Factory(t) { return new (t || UniversalModule)(); };
UniversalModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UniversalModule });
UniversalModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UniversalInterceptorService,
            multi: true // <-- important (you can have many interceptors)
        }
    ], imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UniversalModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [],
                providers: [
                    {
                        provide: HTTP_INTERCEPTORS,
                        useClass: UniversalInterceptorService,
                        multi: true // <-- important (you can have many interceptors)
                    }
                ],
                exports: []
            }]
    }], null, null); })();

const JWT_KEY_NAME = new InjectionToken("jwtKeyName");

class JwtService {
    constructor(uiHelper, jwtKeyName) {
        this.uiHelper = uiHelper;
        this.jwtKeyName = jwtKeyName;
    }
    set token(token) {
        if (this.uiHelper.isBrowser) {
            sessionStorage.setItem(this.jwtKeyName, token);
            this.lastTokenUpdateTime = new Date();
        }
    }
    get token() {
        if (this.uiHelper.isBrowser) {
            return sessionStorage.getItem(this.jwtKeyName);
        }
        return null;
    }
    setToken(token, tokenGroup) {
        if (this.uiHelper.isBrowser) {
            sessionStorage.setItem(tokenGroup || this.jwtKeyName, token);
            this.lastTokenUpdateTime = new Date();
            return { key: tokenGroup || this.jwtKeyName, value: token };
        }
        return null;
    }
    getToken(tokenGroup) {
        if (this.uiHelper.isBrowser) {
            const token = sessionStorage.getItem(tokenGroup || this.jwtKeyName);
            return { key: tokenGroup || this.jwtKeyName, value: token };
        }
        return null;
    }
    cleanToken() {
        if (this.uiHelper.isBrowser) {
            sessionStorage.removeItem(this.jwtKeyName);
            this.lastTokenUpdateTime = null;
        }
    }
}
JwtService.ɵfac = function JwtService_Factory(t) { return new (t || JwtService)(ɵngcc0.ɵɵinject(UiHelperService), ɵngcc0.ɵɵinject(JWT_KEY_NAME)); };
JwtService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: JwtService, factory: JwtService.ɵfac });
JwtService.ctorParameters = () => [
    { type: UiHelperService },
    { type: String, decorators: [{ type: Inject, args: [JWT_KEY_NAME,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(JwtService, [{
        type: Injectable
    }], function () { return [{ type: UiHelperService }, { type: String, decorators: [{
                type: Inject,
                args: [JWT_KEY_NAME]
            }] }]; }, null); })();

class JwtModule {
    static forRoot(jwtKeyName) {
        return {
            ngModule: JwtModule,
            providers: [
                JwtService,
                {
                    provide: JWT_KEY_NAME,
                    useValue: jwtKeyName
                }
            ]
        };
    }
}
JwtModule.ɵfac = function JwtModule_Factory(t) { return new (t || JwtModule)(); };
JwtModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: JwtModule });
JwtModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[
            UiHelperModule.forRoot()
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(JwtModule, [{
        type: NgModule,
        args: [{
                imports: [
                    UiHelperModule.forRoot()
                ],
                declarations: [],
                providers: [],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(JwtModule, { imports: [UiHelperModule] }); })();

class RoutingHistoryService {
    constructor(router) {
        this.router = router;
        this.archive = [];
        this._isFirstPage = true;
        this.setSubscribtions();
    }
    setSubscribtions() {
        this.router.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
                this.archive.push(event.urlAfterRedirects);
            }
        });
    }
    get history() {
        return this.archive ? this.archive : null;
    }
    get previousUrl() {
        return this.archive && this.archive[this.archive.length - 1] ? this.archive[this.archive.length - 1] : '';
    }
    get isFirstPage() {
        if (this._isFirstPage && this.archive && this.archive.length >= 1) {
            this._isFirstPage = false;
        }
        return this._isFirstPage;
    }
}
RoutingHistoryService.ɵfac = function RoutingHistoryService_Factory(t) { return new (t || RoutingHistoryService)(ɵngcc0.ɵɵinject(ɵngcc2.Router)); };
RoutingHistoryService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: RoutingHistoryService, factory: RoutingHistoryService.ɵfac });
RoutingHistoryService.ctorParameters = () => [
    { type: Router }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RoutingHistoryService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.Router }]; }, null); })();

class RoutingModule {
    static forRoot() {
        return {
            ngModule: RoutingModule,
            providers: [
                RoutingHistoryService
            ]
        };
    }
}
RoutingModule.ɵfac = function RoutingModule_Factory(t) { return new (t || RoutingModule)(); };
RoutingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: RoutingModule });
RoutingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RoutingModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [],
                providers: [],
                exports: []
            }]
    }], null, null); })();

const ROLES_TYPE = new InjectionToken('rolesType');

class InitializerService {
    // tslint:disable-next-line:max-line-length
    constructor(httpSvc, platformId, configUrl, clientContextUrl, transferState, request) {
        this.httpSvc = httpSvc;
        this.platformId = platformId;
        this.configUrl = configUrl;
        this.clientContextUrl = clientContextUrl;
        this.transferState = transferState;
        this.request = request;
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    getAppConfigs() {
        return this.appConfigs;
    }
    getClientContext() {
        return this.clientContext;
    }
    init(serverClientContextLoader) {
        const promise = new Promise((resolve, reject) => {
            const clientContextBaseKey = makeStateKey('ClientContextBase');
            this.loadConfigs().subscribe(res => {
                if (!this.isBrowser) {
                    this.clientContext = serverClientContextLoader(this.request);
                    this.transferState.set(clientContextBaseKey, this.clientContext);
                    resolve();
                }
                else {
                    const clientContext = this.transferState.get(clientContextBaseKey, null);
                    if (clientContext) {
                        this.clientContext = clientContext;
                        resolve();
                    }
                    else {
                        this.loadClientContext(this.appConfigs.apiUrl).subscribe(() => {
                            resolve();
                        });
                    }
                }
            });
        });
        return promise;
    }
    loadConfigs() {
        return this.httpSvc
            .get(this.configUrl)
            .pipe(catchError((error) => {
            console.log(`Configuration file "${this.configUrl.substring(this.configUrl.lastIndexOf('/') + 1)}" could not be read`);
            return Observable.throw(error || 'Server error');
        }), (tap(res => {
            this.appConfigs = Object.assign({}, res);
            // if (!this.isBrowser) {
            //   try {
            //     //replace https to http only in server.
            //     this.appConfigs.apiUrl = this.appConfigs.apiUrl.replace(
            //       'https',
            //       'http'
            //     );
            //   } catch (error) {
            //     console.log(
            //       'error in ServerConfigurationService: ' +
            //       error.toString()
            //     );
            //   }
            // }
        })));
    }
    loadClientContext(apiUrl) {
        return this.httpSvc.get(`${apiUrl}${this.clientContextUrl}`).pipe(catchError((error) => {
            console.log(`failed to retrieve client context from ${apiUrl}`);
            return Observable.throw(error || 'Server error');
        }), (tap(res => {
            this.clientContext = res.Result;
        })));
    }
}
InitializerService.ɵfac = function InitializerService_Factory(t) { return new (t || InitializerService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject('CONFIG_URL'), ɵngcc0.ɵɵinject('CLIENT_CONTEXT_URL'), ɵngcc0.ɵɵinject(ɵngcc3.TransferState), ɵngcc0.ɵɵinject(REQUEST, 8)); };
InitializerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function InitializerService_Factory() { return new InitializerService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject("CONFIG_URL"), i0.ɵɵinject("CLIENT_CONTEXT_URL"), i0.ɵɵinject(i4.TransferState), i0.ɵɵinject(i3.REQUEST, 8)); }, token: InitializerService, providedIn: "root" });
InitializerService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: String, decorators: [{ type: Inject, args: ['CONFIG_URL',] }] },
    { type: String, decorators: [{ type: Inject, args: ['CLIENT_CONTEXT_URL',] }] },
    { type: TransferState },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [REQUEST,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InitializerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: ['CONFIG_URL']
            }] }, { type: String, decorators: [{
                type: Inject,
                args: ['CLIENT_CONTEXT_URL']
            }] }, { type: ɵngcc3.TransferState }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [REQUEST]
            }] }]; }, null); })();

/// singleton class per all app
class CoreAuthService {
    constructor(initializerService, rolesType, uiHelper, transferState) {
        this.initializerService = initializerService;
        this.rolesType = rolesType;
        this.uiHelper = uiHelper;
        this.transferState = transferState;
        this.onAuthenticationChangeSubject = new Subject();
        this.isDirty = false;
        this.isUserLoggedIn = false;
        this.isAuthenticatedByServer = false;
        const isAuthStateKey = makeStateKey('IsUserAuthenticated');
        const rolesKey = makeStateKey('Roles');
        if (!this.uiHelper.isBrowser) {
            this.isAuthenticatedByServer = this.initializerService.getClientContext().IsAuthenticated;
            this.rolesToken = this.initializerService.getClientContext().Roles;
            this.transferState.set(isAuthStateKey, this.isAuthenticatedByServer);
            this.transferState.set(rolesKey, this.rolesToken);
        }
        else {
            this.isAuthenticatedByServer = this.transferState.get(isAuthStateKey, false);
            this.rolesToken = this.transferState.get(rolesKey, []);
        }
    }
    isUserAuthenticated() {
        return this.isDirty ? this.isUserLoggedIn : this.isAuthenticatedByServer;
    }
    // if you made any changes to this function do the same for isUserInRoleName function.
    isUserInRole(role) {
        return this.isDirty && this.rolesLoggedIn !== undefined
            ? this.rolesLoggedIn.includes(this.rolesType[role])
            : this.rolesToken !== undefined
                ? this.rolesToken.includes(this.rolesType[role])
                : false;
    }
    isUserMatchRoles(userRoles) {
        for (const userRole of userRoles) {
            if (this.isUserInRole(userRole)) {
                return true;
            }
        }
        return false;
    }
    // if you made any changes to this function do the same for isUserInRole function.
    isUserInRoleName(role) {
        return this.isDirty && this.rolesLoggedIn !== undefined
            ? this.rolesLoggedIn.includes(role)
            : this.rolesToken !== undefined
                ? this.rolesToken.includes(role)
                : false;
    }
    isUserMatchRolesNames(rolesNames) {
        for (const role of rolesNames) {
            if (this.isUserInRoleName(role)) {
                return true;
            }
        }
        return false;
    }
    markUserHasAuthenticated(rolesArray) {
        this.isDirty = true;
        this.isUserLoggedIn = true;
        this.rolesLoggedIn = rolesArray;
        this.onAuthenticationChangeSubject.next(true);
    }
    markUserHasAnonymous() {
        this.isDirty = true;
        this.isUserLoggedIn = false;
        this.rolesLoggedIn = undefined;
        this.rolesToken = undefined;
        this.onAuthenticationChangeSubject.next(false);
    }
    authenticate(roles) {
        this.markUserHasAuthenticated(roles);
    }
    anonymous() {
        this.markUserHasAnonymous();
    }
}
CoreAuthService.ɵfac = function CoreAuthService_Factory(t) { return new (t || CoreAuthService)(ɵngcc0.ɵɵinject(InitializerService), ɵngcc0.ɵɵinject(ROLES_TYPE), ɵngcc0.ɵɵinject(UiHelperService), ɵngcc0.ɵɵinject(ɵngcc3.TransferState)); };
CoreAuthService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CoreAuthService, factory: CoreAuthService.ɵfac });
CoreAuthService.ctorParameters = () => [
    { type: InitializerService },
    { type: undefined, decorators: [{ type: Inject, args: [ROLES_TYPE,] }] },
    { type: UiHelperService },
    { type: TransferState }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CoreAuthService, [{
        type: Injectable
    }], function () { return [{ type: InitializerService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ROLES_TYPE]
            }] }, { type: UiHelperService }, { type: ɵngcc3.TransferState }]; }, null); })();

class AuthHandlerService {
    constructor() {
        // subject with return url as data
        this.notAuthorizedSubject = new Subject();
    }
}
AuthHandlerService.ɵfac = function AuthHandlerService_Factory(t) { return new (t || AuthHandlerService)(); };
AuthHandlerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AuthHandlerService, factory: AuthHandlerService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthHandlerService, [{
        type: Injectable
    }], function () { return []; }, null); })();

// tslint:disable:max-line-length
class AuthGuard {
    constructor(authSvc, router, authHandlerSvc, routingHistorySvc) {
        this.authSvc = authSvc;
        this.router = router;
        this.authHandlerSvc = authHandlerSvc;
        this.routingHistorySvc = routingHistorySvc;
    }
    canActivateChild(childRoute, state) {
        const authConfig = childRoute.data.authConfig;
        if (authConfig) {
            if (this.authSvc.isUserAuthenticated()) {
                if (authConfig.authenticatedRedirectUrl) {
                    this.route(authConfig.authenticatedRedirectUrl, authConfig.preserveParams, childRoute.queryParams, state.url);
                    return false;
                }
                if (authConfig.roles && authConfig.roles.length > 0) {
                    if (this.authSvc.isUserMatchRoles(authConfig.roles)) {
                        return true;
                    }
                    else {
                        this.doWhenNotAuthorized(childRoute, state.url);
                        return false;
                    }
                }
            }
            else {
                if (authConfig.notAuthenticatedRedirectUrl) {
                    this.route(authConfig.notAuthenticatedRedirectUrl, authConfig.preserveParams, childRoute.queryParams, state.url);
                    return false;
                }
                else {
                    if (authConfig.roles && authConfig.roles.length > 0) {
                        this.doWhenNotAuthorized(childRoute, state.url);
                        return false;
                    }
                }
            }
        }
        return true;
    }
    doWhenNotAuthorized(route, returnUrl) {
        if (this.routingHistorySvc.isFirstPage) {
            this.notAuthorizedRedirect(route, returnUrl);
        }
        else {
            this.authHandlerSvc.notAuthorizedSubject.next(returnUrl);
        }
    }
    notAuthorizedRedirect(route, returnUrl) {
        if (!route) {
            throw new Error(`auth guard - Auth Config [notAuthorizedRedirectUrl] is missing for current route`);
        }
        const authConfig = route.data.authConfig;
        if (authConfig && authConfig.notAuthorizedRedirectUrl) {
            this.router.navigate([authConfig.notAuthorizedRedirectUrl], { skipLocationChange: authConfig.notAuthorizedSkipLocation || false, queryParams: authConfig.preserveParams ? Object.assign(Object.assign({}, this.getReturnUrl(authConfig, returnUrl)), route.queryParams) : this.getReturnUrl(authConfig, returnUrl) });
            return;
        }
        this.notAuthorizedRedirect(route.parent, returnUrl);
    }
    getReturnUrl(authConfig, returnUrl) {
        if (authConfig.notAuthorizedSendReturnUrl) {
            return { 'returnUrl': returnUrl };
        }
        return;
    }
    route(url, preserveParams, queryParams, returnUrl) {
        if (preserveParams) {
            this.router.navigate([url], { queryParams, state: { guardReturnUrl: returnUrl } });
        }
        else {
            this.router.navigate([url], { state: { guardReturnUrl: returnUrl } });
        }
    }
}
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵngcc0.ɵɵinject(CoreAuthService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(AuthHandlerService), ɵngcc0.ɵɵinject(RoutingHistoryService)); };
AuthGuard.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AuthGuard, factory: AuthGuard.ɵfac });
AuthGuard.ctorParameters = () => [
    { type: CoreAuthService },
    { type: Router },
    { type: AuthHandlerService },
    { type: RoutingHistoryService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthGuard, [{
        type: Injectable
    }], function () { return [{ type: CoreAuthService }, { type: ɵngcc2.Router }, { type: AuthHandlerService }, { type: RoutingHistoryService }]; }, null); })();

class AuthModule {
    static forRoot(roles) {
        return {
            ngModule: AuthModule,
            providers: [
                {
                    provide: ROLES_TYPE,
                    useValue: roles
                },
                CoreAuthService,
                AuthHandlerService,
                AuthGuard
            ]
        };
    }
}
AuthModule.ɵfac = function AuthModule_Factory(t) { return new (t || AuthModule)(); };
AuthModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AuthModule });
AuthModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[TransferHttpCacheModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthModule, [{
        type: NgModule,
        args: [{
                imports: [TransferHttpCacheModule],
                declarations: [],
                providers: [],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuthModule, { imports: function () { return [TransferHttpCacheModule]; } }); })();

class MaxDialogRef {
    constructor() {
        this.afterCLosed = new EventEmitter();
    }
    close(data) {
        this.afterCLosed.emit(data);
    }
}
class MaxDialogConfig {
}

class MaxDialogInjector {
    constructor(parentInjector, additionalTokens) {
        this.parentInjector = parentInjector;
        this.additionalTokens = additionalTokens;
    }
    get(token, notFoundValue, flags) {
        const injectors = this.additionalTokens.get(token);
        if (injectors) {
            return injectors;
        }
        return this.parentInjector.get(token, notFoundValue);
    }
}

// tslint:disable:directive-selector
class MaxDialogDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
MaxDialogDirective.ɵfac = function MaxDialogDirective_Factory(t) { return new (t || MaxDialogDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
MaxDialogDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MaxDialogDirective, selectors: [["", "maxDialog", ""]] });
MaxDialogDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MaxDialogDirective, [{
        type: Directive,
        args: [{
                selector: '[maxDialog]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();

// tslint:disable:component-selector
class MaxDialogComponent {
    constructor(componentFactoryResolver, cd, dialogRef) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.cd = cd;
        this.dialogRef = dialogRef;
        this.disableScroll();
        setTimeout(() => { this.show = true; }, 0);
    }
    ngAfterViewInit() {
        const viewContainerRef = this.insertionPoint.viewContainerRef;
        viewContainerRef.clear();
        this.componentRef = viewContainerRef.createComponent(this.componentFactoryResolver.resolveComponentFactory(this.childComponentType));
        this.cd.detectChanges();
        fromEvent(document, 'keydown').pipe(filter((e) => e.key === 'Escape'), first()).subscribe(() => {
            this.close();
        });
    }
    ngOnDestroy() {
        const html = document.getElementsByTagName('html')[0];
        html.classList.remove('dialog-scrollblock');
        window.scrollTo(Math.abs(Number(html.style.left.slice(0, -2))), Math.abs(Number(html.style.top.slice(0, -2))));
        html.style.top = ``;
        html.style.left = ``;
    }
    close() {
        this.show = false;
        setTimeout(() => { this.dialogRef.close(); }, 400);
    }
    disableScroll() {
        const html = document.getElementsByTagName('html')[0];
        html.style.top = `-${window.scrollY}px`;
        html.style.left = `-${window.scrollX}px`;
        html.classList.add('dialog-scrollblock');
    }
}
MaxDialogComponent.ɵfac = function MaxDialogComponent_Factory(t) { return new (t || MaxDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(MaxDialogRef)); };
MaxDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MaxDialogComponent, selectors: [["max-dialog"]], viewQuery: function MaxDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(MaxDialogDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.insertionPoint = _t.first);
    } }, decls: 5, vars: 6, consts: [[1, "max-dialog"], [1, "backdrop", 3, "ngClass", "click"], [1, "container"], [1, "content", 3, "ngClass"], ["maxDialog", ""]], template: function MaxDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function MaxDialogComponent_Template_div_click_1_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, MaxDialogComponent_ng_template_4_Template, 0, 0, "ng-template", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c0, ctx.show));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c0, ctx.show));
    } }, directives: [ɵngcc4.NgClass, MaxDialogDirective], styles: [".max-dialog{position:fixed;display:-webkit-box;display:-ms-flexbox;display:flex;z-index:1000;height:100%;width:100%;left:0;top:0}.max-dialog .backdrop{-webkit-transition:opacity .4s cubic-bezier(.25,.8,.25,1);-o-transition:opacity .4s cubic-bezier(.25,.8,.25,1);transition:opacity .4s cubic-bezier(.25,.8,.25,1);-webkit-tap-highlight-color:transparent;background:rgba(0,0,0,.32);pointer-events:auto;position:absolute;z-index:1000;opacity:0;bottom:0;right:0;left:0;top:0}.max-dialog .backdrop.show{opacity:1}.max-dialog .container{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;pointer-events:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex;z-index:1000;bottom:0;right:0;left:0;top:0}.max-dialog .container .content{-webkit-box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);color:rgba(0,0,0,.87);-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transition:all .4s;-o-transition:all .4s;transition:all .4s;-webkit-transform:scale(.8);-ms-transform:scale(.8);transform:scale(.8);pointer-events:auto;min-height:inherit;max-height:inherit;background:#fff;border-radius:4px;position:static;max-width:80vw;overflow:auto;display:block;padding:24px;opacity:0;outline:0}.max-dialog .container .content.show{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);opacity:1}.dialog-scrollblock{overflow-y:scroll;position:fixed;width:100%}"], encapsulation: 2 });
MaxDialogComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ChangeDetectorRef },
    { type: MaxDialogRef }
];
MaxDialogComponent.propDecorators = {
    insertionPoint: [{ type: ViewChild, args: [MaxDialogDirective,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MaxDialogComponent, [{
        type: Component,
        args: [{
                selector: 'max-dialog',
                template: "<div class=\"max-dialog\">\r\n\r\n    <div (click)=\"close()\" class=\"backdrop\" [ngClass]=\"{'show': show}\"></div>\r\n\r\n    <div class=\"container\">\r\n\r\n        <div class=\"content\" [ngClass]=\"{'show': show}\">\r\n\r\n            <ng-template maxDialog></ng-template>\r\n\r\n        </div>\r\n\r\n    </div>\r\n\r\n</div>\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".max-dialog{position:fixed;display:-webkit-box;display:-ms-flexbox;display:flex;z-index:1000;height:100%;width:100%;left:0;top:0}.max-dialog .backdrop{-webkit-transition:opacity .4s cubic-bezier(.25,.8,.25,1);-o-transition:opacity .4s cubic-bezier(.25,.8,.25,1);transition:opacity .4s cubic-bezier(.25,.8,.25,1);-webkit-tap-highlight-color:transparent;background:rgba(0,0,0,.32);pointer-events:auto;position:absolute;z-index:1000;opacity:0;bottom:0;right:0;left:0;top:0}.max-dialog .backdrop.show{opacity:1}.max-dialog .container{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;pointer-events:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex;z-index:1000;bottom:0;right:0;left:0;top:0}.max-dialog .container .content{-webkit-box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);color:rgba(0,0,0,.87);-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transition:all .4s;-o-transition:all .4s;transition:all .4s;-webkit-transform:scale(.8);-ms-transform:scale(.8);transform:scale(.8);pointer-events:auto;min-height:inherit;max-height:inherit;background:#fff;border-radius:4px;position:static;max-width:80vw;overflow:auto;display:block;padding:24px;opacity:0;outline:0}.max-dialog .container .content.show{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);opacity:1}.dialog-scrollblock{overflow-y:scroll;position:fixed;width:100%}"]
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ChangeDetectorRef }, { type: MaxDialogRef }]; }, { insertionPoint: [{
            type: ViewChild,
            args: [MaxDialogDirective]
        }] }); })();

class MaxDialogModule {
}
MaxDialogModule.ɵfac = function MaxDialogModule_Factory(t) { return new (t || MaxDialogModule)(); };
MaxDialogModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MaxDialogModule });
MaxDialogModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MaxDialogModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [MaxDialogComponent, MaxDialogDirective],
                entryComponents: [MaxDialogComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MaxDialogModule, { declarations: function () { return [MaxDialogComponent, MaxDialogDirective]; }, imports: function () { return [CommonModule]; } }); })();

// tslint:disable:max-line-length
class MaxDialogService {
    constructor(componentFactoryResolver, appRef, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
    }
    open(componentType, config) {
        if (!document) {
            throw new Error('Document is not defined, Make sure you are in a browser environment');
        }
        const dialogRef = new MaxDialogRef();
        dialogRef.afterCLosed.pipe(first()).subscribe(() => {
            this.removeDialog();
        });
        const componentRef = this.componentFactoryResolver.resolveComponentFactory(MaxDialogComponent).create(this.getDialogInjector(dialogRef, config));
        this.appRef.attachView(componentRef.hostView);
        document.body.appendChild(componentRef.hostView.rootNodes[0]);
        componentRef.instance.childComponentType = componentType;
        this.dialogComponentRef = componentRef;
        return dialogRef;
    }
    getDialogInjector(dialogRef, config) {
        const weakMap = new WeakMap();
        weakMap.set(MaxDialogConfig, config);
        weakMap.set(MaxDialogRef, dialogRef);
        return new MaxDialogInjector(this.injector, weakMap);
    }
    removeDialog() {
        this.appRef.detachView(this.dialogComponentRef.hostView);
        this.dialogComponentRef.destroy();
    }
}
MaxDialogService.ɵfac = function MaxDialogService_Factory(t) { return new (t || MaxDialogService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
MaxDialogService.ɵprov = i0.ɵɵdefineInjectable({ factory: function MaxDialogService_Factory() { return new MaxDialogService(i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(i0.INJECTOR)); }, token: MaxDialogService, providedIn: MaxDialogModule });
MaxDialogService.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ApplicationRef },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MaxDialogService, [{
        type: Injectable,
        args: [{
                providedIn: MaxDialogModule
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.Injector }]; }, null); })();

// tslint:disable:max-line-length
class AnalyticsService {
    constructor(router, authService, helper) {
        this.router = router;
        this.authService = authService;
        this.helper = helper;
        this.defaultAnalytics = {};
        this.listenToRouter();
    }
    push(analytics) {
        // console.log({ local: JSON.parse(JSON.stringify(analytics)), global: this.analytics, merged: { ...this.analytics, ...analytics } });
        if (!analytics.dontPush && this.helper.isBrowser) {
            analytics = Object.assign(Object.assign({}, this.defaultAnalytics), analytics);
            if (analytics.useAuthInfo) {
                analytics.category = this.getRegisterInfo(analytics.category);
            }
            // tslint:disable-next-line: no-string-literal
            if (window['dataLayer']) {
                // tslint:disable-next-line: no-string-literal
                window['dataLayer'].push({
                    Category: analytics.category,
                    Action: analytics.action,
                    Label: analytics.label,
                    SubjectId: analytics.subjectId,
                    WorkflowDescription: analytics.workflowDescription,
                    WorkflowStep: analytics.workflowStep,
                    WorkflowTotalStep: analytics.workflowTotalStep,
                    event: 'auto_event'
                });
            }
            else {
                console.log(`Can't push to google analytics`, analytics);
            }
        }
    }
    getRegisterInfo(field) {
        if (!field || (field.includes('registered') || field.includes('anonymous'))) {
            return field;
        }
        return `${field} - ${this.authService.isUserAuthenticated() ? 'registered' : 'anonymous'}`;
    }
    getDefaultAnalytics() {
        return this.defaultAnalytics;
    }
    setDefaultAnalytics(analytics) {
        this.defaultAnalytics = analytics;
    }
    listenToRouter() {
        let isNewNavigation = true;
        this.router.events.pipe(filter(x => x instanceof ActivationEnd || x instanceof NavigationEnd)).subscribe((res) => {
            if (res instanceof NavigationEnd) {
                isNewNavigation = true;
            }
            else if (isNewNavigation) {
                const routeAnalytics = res.snapshot.data.analytics;
                if (routeAnalytics) {
                    this.defaultAnalytics = routeAnalytics;
                }
                isNewNavigation = false;
            }
        });
    }
}
AnalyticsService.ɵfac = function AnalyticsService_Factory(t) { return new (t || AnalyticsService)(ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(CoreAuthService), ɵngcc0.ɵɵinject(UiHelperService)); };
AnalyticsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AnalyticsService_Factory() { return new AnalyticsService(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(CoreAuthService), i0.ɵɵinject(UiHelperService)); }, token: AnalyticsService, providedIn: "root" });
AnalyticsService.ctorParameters = () => [
    { type: Router },
    { type: CoreAuthService },
    { type: UiHelperService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AnalyticsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc2.Router }, { type: CoreAuthService }, { type: UiHelperService }]; }, null); })();

class AnalyticsDirective {
    constructor(element, analyticsService) {
        this.element = element;
        this.analyticsService = analyticsService;
    }
    ngOnInit() {
        this.element.nativeElement.addEventListener('click', () => {
            this.analyticsService.push(this.analytics);
        });
    }
}
AnalyticsDirective.ɵfac = function AnalyticsDirective_Factory(t) { return new (t || AnalyticsDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(AnalyticsService)); };
AnalyticsDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AnalyticsDirective, selectors: [["", "analytics", ""]], inputs: { analytics: "analytics" } });
AnalyticsDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: AnalyticsService }
];
AnalyticsDirective.propDecorators = {
    analytics: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AnalyticsDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[analytics]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: AnalyticsService }]; }, { analytics: [{
            type: Input
        }] }); })();

class LoggerHandlerServiceAbstract {
}
LoggerHandlerServiceAbstract.ɵfac = function LoggerHandlerServiceAbstract_Factory(t) { return new (t || LoggerHandlerServiceAbstract)(); };
LoggerHandlerServiceAbstract.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LoggerHandlerServiceAbstract, factory: LoggerHandlerServiceAbstract.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoggerHandlerServiceAbstract, [{
        type: Injectable
    }], null, null); })();

/**
 * LogHandlingService gives you an option to use a LoggerService service
 * in case you can't inject it (LoggerService) because of cyclic dependency!
 */
class LoggerHandlerService extends LoggerHandlerServiceAbstract {
    constructor() {
        super(...arguments);
        this.log = new Subject();
        this.warning = new Subject();
        this.error = new Subject();
        this.fatal = new Subject();
        this.logCompleted = new Subject();
        this.warningCompleted = new Subject();
        this.errorCompleted = new Subject();
        this.fatalCompleted = new Subject();
    }
}
LoggerHandlerService.ɵfac = /*@__PURE__*/ function () { let ɵLoggerHandlerService_BaseFactory; return function LoggerHandlerService_Factory(t) { return (ɵLoggerHandlerService_BaseFactory || (ɵLoggerHandlerService_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(LoggerHandlerService)))(t || LoggerHandlerService); }; }();
LoggerHandlerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LoggerHandlerService, factory: LoggerHandlerService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoggerHandlerService, [{
        type: Injectable
    }], null, null); })();

class AppLinkDirective {
    constructor(serverUrl, el, renderer, uiHelper, router, loggerHandler) {
        this.serverUrl = serverUrl;
        this.el = el;
        this.renderer = renderer;
        this.uiHelper = uiHelper;
        this.router = router;
        this.loggerHandler = loggerHandler;
        this.linkForRouterLink = undefined;
        this.params = {};
        this.defaultUrlSerializer = new DefaultUrlSerializer;
        this.originUrl = this.uiHelper.isBrowser ? window.location.origin : this.serverUrl;
    }
    ngOnInit() {
        if (this.uiHelper.isBrowser) {
            this.setLink();
        }
    }
    ngOnChanges(changes) {
        if (this.uiHelper.isBrowser) {
            this.setLink();
        }
    }
    setLink() {
        if (!this.anchorLink) {
            return;
        }
        try {
            if (this.isOpenLinkInNewTab) {
                this.renderer.setAttribute(this.el.nativeElement, 'href', this.anchorLink);
            }
            else if (this.anchorLink[0] === '/') {
                this.linkForRouterLink = this.anchorLink.split('?')[0];
                this.params = this.defaultUrlSerializer.parse(this.anchorLink).queryParams;
            }
            else {
                let fullDomain = this.originUrl.split('/')[2];
                let baseUrl = this.anchorLink.split('/')[2];
                let relUrl = this.anchorLink.split(baseUrl)[1];
                if (baseUrl &&
                    relUrl &&
                    relUrl.toLowerCase().indexOf('/he-il/') < 0 &&
                    fullDomain &&
                    baseUrl.toLowerCase().indexOf(fullDomain.toLowerCase()) > -1) {
                    this.linkForRouterLink = relUrl.split('?')[0];
                    this.params = this.defaultUrlSerializer.parse(relUrl).queryParams;
                }
                else {
                    this.renderer.setAttribute(this.el.nativeElement, 'href', this.anchorLink);
                }
            }
        }
        catch (e) {
            this.loggerHandler.error.next(`link from umbraco: ${this.anchorLink} fails to parse due to ${e.toString()}`);
        }
    }
    click() {
        if (this.uiHelper.isBrowser && this.linkForRouterLink !== undefined) {
            this.router.navigate([this.linkForRouterLink], { queryParams: this.params });
        }
    }
}
AppLinkDirective.ɵfac = function AppLinkDirective_Factory(t) { return new (t || AppLinkDirective)(ɵngcc0.ɵɵdirectiveInject('serverUrl', 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(UiHelperService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(LoggerHandlerService)); };
AppLinkDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AppLinkDirective, selectors: [["", "appLink", ""]], hostBindings: function AppLinkDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function AppLinkDirective_click_HostBindingHandler() { return ctx.click(); });
    } }, inputs: { anchorLink: "anchorLink", isOpenLinkInNewTab: "isOpenLinkInNewTab" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
AppLinkDirective.ctorParameters = () => [
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: ['serverUrl',] }] },
    { type: ElementRef },
    { type: Renderer2 },
    { type: UiHelperService },
    { type: Router },
    { type: LoggerHandlerService }
];
AppLinkDirective.propDecorators = {
    anchorLink: [{ type: Input }],
    isOpenLinkInNewTab: [{ type: Input }],
    click: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppLinkDirective, [{
        type: Directive,
        args: [{
                selector: '[appLink]'
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: ['serverUrl']
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: UiHelperService }, { type: ɵngcc2.Router }, { type: LoggerHandlerService }]; }, { click: [{
            type: HostListener,
            args: ['click']
        }], anchorLink: [{
            type: Input
        }], isOpenLinkInNewTab: [{
            type: Input
        }] }); })();

class MaxCommonModule {
}
MaxCommonModule.ɵfac = function MaxCommonModule_Factory(t) { return new (t || MaxCommonModule)(); };
MaxCommonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MaxCommonModule });
MaxCommonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [LoggerHandlerService] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MaxCommonModule, [{
        type: NgModule,
        args: [{
                declarations: [AnalyticsDirective, AppLinkDirective],
                exports: [AnalyticsDirective, AppLinkDirective],
                providers: [LoggerHandlerService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MaxCommonModule, { declarations: [AnalyticsDirective, AppLinkDirective], exports: [AnalyticsDirective, AppLinkDirective] }); })();

var LogType;
(function (LogType) {
    LogType[LogType["Info"] = 0] = "Info";
    LogType[LogType["Warning"] = 1] = "Warning";
    LogType[LogType["Error"] = 2] = "Error";
    LogType[LogType["Fatal"] = 3] = "Fatal";
})(LogType || (LogType = {}));

const LOGS_URL = new InjectionToken("logsUrl");

class LoggerService {
    constructor(platformId, loggerHandler, httpSvc, logsUrl, initializer) {
        this.platformId = platformId;
        this.loggerHandler = loggerHandler;
        this.httpSvc = httpSvc;
        this.logsUrl = logsUrl;
        this.initializer = initializer;
        this.sync = {
            log: (message) => {
                return this.sendLogSync(message, LogType.Info);
            },
            warning: (message) => {
                return this.sendLogSync(message, LogType.Warning);
            },
            error: (message) => {
                return this.sendLogSync(message, LogType.Error);
            },
            fatal: (message) => {
                return this.sendLogSync(message, LogType.Fatal);
            }
        };
        this.isBrowser = isPlatformBrowser(platformId);
        this.setLoggerHandlingServiceSubscriptions();
    }
    setLoggerHandlingServiceSubscriptions() {
        this.loggerHandler.log.subscribe((message) => {
            this.sendLogSync(message, LogType.Info).subscribe(() => {
                this.loggerHandler.logCompleted.next(message);
            }, () => {
                this.loggerHandler.logCompleted.next(message);
            });
        });
        this.loggerHandler.warning.subscribe((message) => {
            this.sendLogSync(message, LogType.Warning).subscribe(() => {
                this.loggerHandler.warningCompleted.next(message);
            }, () => {
                this.loggerHandler.warningCompleted.next(message);
            });
        });
        this.loggerHandler.error.subscribe((message) => {
            this.sendLogSync(message, LogType.Error).subscribe(() => {
                this.loggerHandler.errorCompleted.next(message);
            }, () => {
                this.loggerHandler.errorCompleted.next(message);
            });
        });
        this.loggerHandler.fatal.subscribe((message) => {
            this.sendLogSync(message, LogType.Fatal).subscribe(() => {
                this.loggerHandler.fatalCompleted.next(message);
            }, () => {
                this.loggerHandler.fatalCompleted.next(message);
            });
        });
    }
    log(message) {
        this.sendLog(message, LogType.Info);
    }
    warning(message) {
        this.sendLog(message, LogType.Warning);
    }
    error(message) {
        this.sendLog(message, LogType.Error);
    }
    fatal(message) {
        this.sendLog(message, LogType.Fatal);
    }
    sendLog(message, logType) {
        if (this.isBrowser) {
            this.httpSvc.post(this.getLogsApiUrl(), this.buildMessage(message, logType)).subscribe((res) => { });
        }
    }
    sendLogSync(message, logType) {
        if (this.isBrowser) {
            return this.httpSvc.post(this.getLogsApiUrl(), this.buildMessage(message, logType));
        }
        else {
            return new Observable(observer => {
                observer.next();
            });
        }
    }
    buildMessage(message, logType) {
        let log = {
            Message: message,
            Type: logType
        };
        return log;
    }
    getLogsApiUrl() {
        return this.initializer.getAppConfigs().apiUrl + this.logsUrl;
    }
}
LoggerService.ɵfac = function LoggerService_Factory(t) { return new (t || LoggerService)(ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(LoggerHandlerService), ɵngcc0.ɵɵinject(HttpService), ɵngcc0.ɵɵinject(LOGS_URL), ɵngcc0.ɵɵinject(InitializerService)); };
LoggerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LoggerService, factory: LoggerService.ɵfac });
LoggerService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: LoggerHandlerService },
    { type: HttpService },
    { type: String, decorators: [{ type: Inject, args: [LOGS_URL,] }] },
    { type: InitializerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoggerService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: LoggerHandlerService }, { type: HttpService }, { type: String, decorators: [{
                type: Inject,
                args: [LOGS_URL]
            }] }, { type: InitializerService }]; }, null); })();

class LoggerHelperService {
    constructor(platformId) {
        this.platformId = platformId;
        this.isBrowser = isPlatformBrowser(platformId);
        this.setCorrelationId();
        if (!this.sessionId) {
            this.setSessionId();
        }
    }
    get correlationId() {
        return this._correlationId;
    }
    setCorrelationId() {
        this._correlationId = v4();
    }
    get sessionId() {
        if (this.isBrowser) {
            return sessionStorage.getItem('SessionId');
        }
        return null;
    }
    setSessionId() {
        if (this.isBrowser) {
            sessionStorage.setItem('SessionId', v4());
        }
    }
}
LoggerHelperService.ɵfac = function LoggerHelperService_Factory(t) { return new (t || LoggerHelperService)(ɵngcc0.ɵɵinject(PLATFORM_ID)); };
LoggerHelperService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LoggerHelperService, factory: LoggerHelperService.ɵfac });
LoggerHelperService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoggerHelperService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();

class LoggerListenerService {
    constructor(platformId, router, zone, logger, routingHistoryService, title, loggerHelperService) {
        this.platformId = platformId;
        this.router = router;
        this.zone = zone;
        this.logger = logger;
        this.routingHistoryService = routingHistoryService;
        this.title = title;
        this.loggerHelperService = loggerHelperService;
        this.isBrowser = isPlatformBrowser(platformId);
        this.setRoutingListeningLogging();
        this.setErrorListeningLogging();
        this.setUserClickListeningLogging();
        // this.setDomListeningLogging();
    }
    handleClick(event) { }
    ;
    setRoutingListeningLogging() {
        this.router.events.forEach((event) => {
            switch (event.constructor) {
                case NavigationStart:
                    if (this.routingHistoryService.isFirstPage) {
                        this.logger.log('User enter the application URL [' + event.url + ']');
                    }
                    break;
                case NavigationEnd:
                    this.logger.log('User entered page [' + this.title.getTitle() + ']');
                    break;
                case NavigationCancel:
                    this.logger.warning('User navigation to URL [' + event.url + '] was canceled');
                    break;
                // case NavigationError:
                //     this.logger.log("An error occurred while navigating user to url [" + (event as NavigationError).url + "]");
                //     break;
                // case RoutesRecognized:
                //     this.logger.log("User navigation route [" + (event as RoutesRecognized).url + "] was recognized");
                //     break;
            }
        });
    }
    setErrorListeningLogging() {
        this.zone.onError.subscribe((event) => {
            let errorMessage = `ANGULAR. Error [${event}]`;
            if (event.message) {
                errorMessage += ` Message [${event.message}]`;
            }
            if (event.name) {
                errorMessage += ` Name [${event.name}]`;
            }
            // if (!isNullOrUndefined(event.stack)) {
            //    errorMessage += ` Stack [${event.stack}]`;
            // }
            this.logger.warning(errorMessage);
        });
    }
    setUserClickListeningLogging() {
        if (this.isBrowser) {
            // "handleClick" content is handled by JS outside of angular scope
            // at the moment of execution "this" is "document"
            // this is why "that" is needed - to save the context of the service
            const that = this;
            this.handleClick = function (event) {
                if (event && event.path && event.path.length > 0) {
                    const elements = event.path.filter(p => p instanceof HTMLButtonElement || p instanceof HTMLAnchorElement);
                    if (elements.length > 0) {
                        const element = elements[0];
                        that.loggerHelperService.setCorrelationId();
                        that.logger.log('User clicked [' + element.nodeName + '] with text [' + element.textContent + ']');
                    }
                }
            };
            document.addEventListener('click', this.handleClick);
            window.onbeforeunload = () => {
                document.removeEventListener('click', this.handleClick, false);
            };
        }
    }
}
LoggerListenerService.ɵfac = function LoggerListenerService_Factory(t) { return new (t || LoggerListenerService)(ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(LoggerService), ɵngcc0.ɵɵinject(RoutingHistoryService), ɵngcc0.ɵɵinject(ɵngcc3.Title), ɵngcc0.ɵɵinject(LoggerHelperService)); };
LoggerListenerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LoggerListenerService, factory: LoggerListenerService.ɵfac });
LoggerListenerService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: Router },
    { type: NgZone },
    { type: LoggerService },
    { type: RoutingHistoryService },
    { type: Title },
    { type: LoggerHelperService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoggerListenerService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc2.Router }, { type: ɵngcc0.NgZone }, { type: LoggerService }, { type: RoutingHistoryService }, { type: ɵngcc3.Title }, { type: LoggerHelperService }]; }, null); })();

class HttpServiceLogInterceptor {
    constructor(platformId, routingHistoryService, loggerHelperService, initializerService, logsUrl) {
        this.platformId = platformId;
        this.routingHistoryService = routingHistoryService;
        this.loggerHelperService = loggerHelperService;
        this.initializerService = initializerService;
        this.logsUrl = logsUrl;
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    intercept(req, next) {
        var _a;
        if (!this.isBrowser) {
            return next.handle(req);
        }
        let newReq = req.clone({
            setHeaders: {
                'SID': this.loggerHelperService.sessionId || '',
                'CID': !req.url.includes(this.logsUrl) ? (this.loggerHelperService.correlationId || '') : '',
                'URF': this.routingHistoryService.previousUrl || '',
                'CAV': ((_a = this.initializerService.getClientContext()) === null || _a === void 0 ? void 0 : _a.Version) || ''
            }
        });
        return next.handle(newReq);
    }
}
HttpServiceLogInterceptor.ɵfac = function HttpServiceLogInterceptor_Factory(t) { return new (t || HttpServiceLogInterceptor)(ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(RoutingHistoryService), ɵngcc0.ɵɵinject(LoggerHelperService), ɵngcc0.ɵɵinject(InitializerService), ɵngcc0.ɵɵinject(LOGS_URL)); };
HttpServiceLogInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: HttpServiceLogInterceptor, factory: HttpServiceLogInterceptor.ɵfac });
HttpServiceLogInterceptor.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: RoutingHistoryService },
    { type: LoggerHelperService },
    { type: InitializerService },
    { type: String, decorators: [{ type: Inject, args: [LOGS_URL,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HttpServiceLogInterceptor, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: RoutingHistoryService }, { type: LoggerHelperService }, { type: InitializerService }, { type: String, decorators: [{
                type: Inject,
                args: [LOGS_URL]
            }] }]; }, null); })();

class ServerClientContextLoader {
}
ServerClientContextLoader.ɵfac = function ServerClientContextLoader_Factory(t) { return new (t || ServerClientContextLoader)(); };
ServerClientContextLoader.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ServerClientContextLoader, factory: ServerClientContextLoader.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServerClientContextLoader, [{
        type: Injectable
    }], null, null); })();

function init_app(initializer, serverLoader) {
    const initAppFunction = () => { return initializer.init(serverLoader.load); };
    return initAppFunction;
}
class InitializerModule {
    static forRoot(configUrl, clientContextUrl, serverLoader) {
        return {
            ngModule: InitializerModule,
            providers: [
                {
                    provide: 'CONFIG_URL',
                    useValue: configUrl
                },
                {
                    provide: 'CLIENT_CONTEXT_URL',
                    useValue: clientContextUrl
                },
                { provide: ServerClientContextLoader, useClass: serverLoader }
            ]
        };
    }
}
InitializerModule.ɵfac = function InitializerModule_Factory(t) { return new (t || InitializerModule)(); };
InitializerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: InitializerModule });
InitializerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: init_app,
            deps: [InitializerService, ServerClientContextLoader],
            multi: true
        }
    ], imports: [[
            HttpClientModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InitializerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    HttpClientModule
                ],
                declarations: [],
                providers: [
                    {
                        provide: APP_INITIALIZER,
                        useFactory: init_app,
                        deps: [InitializerService, ServerClientContextLoader],
                        multi: true
                    }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InitializerModule, { imports: function () { return [HttpClientModule]; } }); })();

class LoggingModule {
    static forRoot(logsUrl) {
        return {
            ngModule: LoggingModule,
            providers: [
                {
                    provide: LOGS_URL,
                    useValue: logsUrl
                }
            ]
        };
    }
}
LoggingModule.ɵfac = function LoggingModule_Factory(t) { return new (t || LoggingModule)(); };
LoggingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LoggingModule });
LoggingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        LoggerListenerService,
        LoggerHandlerService,
        LoggerService,
        LoggerHelperService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpServiceLogInterceptor,
            multi: true
        }
    ], imports: [[
            InitializerModule,
            HttpModule,
            RoutingModule.forRoot()
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoggingModule, [{
        type: NgModule,
        args: [{
                imports: [
                    InitializerModule,
                    HttpModule,
                    RoutingModule.forRoot()
                ],
                declarations: [],
                providers: [
                    LoggerListenerService,
                    LoggerHandlerService,
                    LoggerService,
                    LoggerHelperService,
                    {
                        provide: HTTP_INTERCEPTORS,
                        useClass: HttpServiceLogInterceptor,
                        multi: true
                    }
                ],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LoggingModule, { imports: [InitializerModule, HttpModule, RoutingModule] }); })();

class WrongUrlInterceptor {
    constructor(platformId, loggerHandler) {
        this.platformId = platformId;
        this.loggerHandler = loggerHandler;
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    intercept(req, next) {
        if (!this.isBrowser || req.url.includes('logs/log')) {
            return next.handle(req);
        }
        return next.handle(req).pipe(tap(event => {
            if (event instanceof HttpResponse) {
                if (this.isBlockedByNetSec(event)) {
                    this.loggerHandler.error.next(`URL [${req.url}] with method [${req.method}] is blocked by netsec. Payload [${JSON.stringify(event.body)}]`);
                }
            }
            if (event instanceof HttpErrorResponse) {
                if (this.isBrowser) {
                    if (this.isBlockedByNetSec(event)) {
                        this.loggerHandler.error.next(`URL [${req.url}] with method [${req.method}] is blocked by netsec`);
                    }
                }
            }
        }, error => {
            if (this.isBlockedByNetSec(error)) {
                this.loggerHandler.error.next(`URL [${req.url}] with method [${req.method}] is blocked by netsec`);
            }
        }));
    }
    isBlockedByNetSec(res) {
        return res.status === 202 || res.headers.has('x-netsec-block');
    }
}
WrongUrlInterceptor.ɵfac = function WrongUrlInterceptor_Factory(t) { return new (t || WrongUrlInterceptor)(ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(LoggerHandlerServiceAbstract)); };
WrongUrlInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: WrongUrlInterceptor, factory: WrongUrlInterceptor.ɵfac });
WrongUrlInterceptor.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: LoggerHandlerServiceAbstract }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WrongUrlInterceptor, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: LoggerHandlerServiceAbstract }]; }, null); })();

class CookiesService {
}
CookiesService.ɵfac = function CookiesService_Factory(t) { return new (t || CookiesService)(); };
CookiesService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CookiesService, factory: CookiesService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CookiesService, [{
        type: Injectable
    }], null, null); })();

class SeoService {
    constructor(router, httpSvc, initializer, metasrv, titlesrv, route, serverService, document) {
        this.router = router;
        this.httpSvc = httpSvc;
        this.initializer = initializer;
        this.metasrv = metasrv;
        this.titlesrv = titlesrv;
        this.route = route;
        this.serverService = serverService;
        this.document = document;
    }
    start() {
        this.serverService.server8Mode$.subscribe(v => {
            let title = this.titlesrv.getTitle();
            if (v) {
                if (!title.includes('שדרה 8')) {
                    this.titlesrv.setTitle('שדרה 8 ' + title);
                }
            }
            else {
                if (title.includes('שדרה 8')) {
                    this.titlesrv.setTitle(title.replace('שדרה 8', '').trim());
                }
            }
        });
        this.serverService.server10Mode$.subscribe(v => {
            let title = this.titlesrv.getTitle();
            if (v) {
                if (!title.includes('שדרה 10')) {
                    this.titlesrv.setTitle('שדרה 10 ' + title);
                }
            }
            else {
                if (title.includes('שדרה 10')) {
                    this.titlesrv.setTitle(title.replace('שדרה 10', '').trim());
                }
            }
        });
        let apiUrl = this.initializer.getAppConfigs().apiUrl;
        this.router.events.pipe(filter(e => e instanceof NavigationEnd && ['/cards/card', '/benefits/lobby'].every(str => !e.urlAfterRedirects.toLowerCase().startsWith(str))), map((e) => ({ e: e, route: this.route.snapshot })), map((obj) => {
            while (obj.route.firstChild) {
                obj.route = obj.route.firstChild;
            }
            return ({ e: obj.e, route: obj.route });
        }), filter((obj) => !obj.route.data || !obj.route.data['skipSeoPageData']), map((obj) => obj.e.urlAfterRedirects.split('?')[0])).subscribe(path => {
            this.httpSvc.get(`${apiUrl}/seopagedata/getPage?routePageId=${path}`).subscribe(seo => { if (seo.Result)
                this.setSeoPageData(seo.Result, path); });
        });
    }
    setQuestionAndAnswers(questionsAndAnswers) {
        if (!questionsAndAnswers || this.document.querySelector(`script[id="faqScript"]`)) {
            return;
        }
        let data = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": []
        };
        data['mainEntity'] = questionsAndAnswers.map(qa => this.buildItemForFaq(qa.QuestionText, qa.AnswerText));
        let node = this.document.createElement('script');
        node.type = 'application/ld+json';
        node.async = true;
        node.charset = 'utf-8';
        node.innerHTML = JSON.stringify(data);
        node.id = 'faqScript';
        this.document.getElementsByTagName('head')[0].appendChild(node);
    }
    buildItemForFaq(q, a) {
        let item = {
            "@type": "Question",
            "name": null,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": null
            }
        };
        item['name'] = q;
        item['acceptedAnswer']['text'] = a;
        return item;
    }
    setImages(images) {
        if (!images || this.document.querySelector(`script[id="imagesScript"]`)) {
            return;
        }
        let data = {
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "image": []
        };
        data['image'] = images.map(i => i.Url);
        let node = this.document.createElement('script');
        node.type = 'application/ld+json';
        node.async = true;
        node.charset = 'utf-8';
        node.innerHTML = JSON.stringify(data);
        node.id = 'imagesScript';
        this.document.getElementsByTagName('head')[0].appendChild(node);
    }
    setSeoPagesData(res, routePageId) {
        let result = this.getResultByPageId(res, routePageId);
        this.setSeoPageData(result, routePageId);
    }
    setSeoPageData(seo, routePageId) {
        if (seo) {
            this.setTitle(seo.Title);
            this.setDescription(seo.Description);
            this.setKeywords(seo.Keywords);
            this.setQuestionAndAnswers(seo.QuestionsAndAnswers);
            this.setImages(seo.Images);
        }
        else {
            // this.logger.warning(`seo data not found for path: ${routePageId}`);
        }
    }
    // recursivly search through the path hierarchy to find the most specific definition in the list
    getResultByPageId(res, routePageId) {
        let result = res.SeoPageDataList.find(seo => seo.PageId.toLowerCase() === routePageId.toLowerCase());
        if (result) {
            return result;
        }
        let pathSplit = routePageId.split('/');
        let pageId = pathSplit.slice(0, pathSplit.length - 1).join('/');
        if (!pageId) {
            return res.SeoPageDataList.find(seo => seo.PageId.toLowerCase() === "/");
        }
        return this.getResultByPageId(res, pageId);
    }
    setTitle(title) {
        if (title) {
            this.titlesrv.setTitle(title);
            if (this.serverService.isCookieEnabled('eve', '8')) {
                this.serverService.server8Mode$.next(true);
            }
            if (this.serverService.isCookieEnabled('eve', '10')) {
                this.serverService.server10Mode$.next(true);
            }
        }
    }
    setDescription(description) {
        if (description) {
            this.metasrv.updateTag({ name: 'description', content: description });
            const desc = this.document.querySelector('head > meta[name=description]');
            this.hoistElement(desc);
        }
    }
    setKeywords(keywords) {
        if (keywords) {
            this.metasrv.updateTag({ name: 'keywords', content: keywords });
            const keywordsEle = this.document.querySelector('head > meta[name=keywords]');
            this.hoistElement(keywordsEle);
        }
    }
    hoistElement(element) {
        if (!element) {
            return;
        }
        this.document.head.insertBefore(element, this.document.head.firstChild);
    }
}
SeoService.ɵfac = function SeoService_Factory(t) { return new (t || SeoService)(ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(InitializerService), ɵngcc0.ɵɵinject(ɵngcc3.Meta), ɵngcc0.ɵɵinject(ɵngcc3.Title), ɵngcc0.ɵɵinject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵinject(CookiesService), ɵngcc0.ɵɵinject(DOCUMENT)); };
SeoService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SeoService_Factory() { return new SeoService(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(InitializerService), i0.ɵɵinject(i4.Meta), i0.ɵɵinject(i4.Title), i0.ɵɵinject(i1$1.ActivatedRoute), i0.ɵɵinject(CookiesService), i0.ɵɵinject(i6.DOCUMENT)); }, token: SeoService, providedIn: "root" });
SeoService.ctorParameters = () => [
    { type: Router },
    { type: HttpClient },
    { type: InitializerService },
    { type: Meta },
    { type: Title },
    { type: ActivatedRoute },
    { type: CookiesService },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.Router }, { type: ɵngcc1.HttpClient }, { type: InitializerService }, { type: ɵngcc3.Meta }, { type: ɵngcc3.Title }, { type: ɵngcc2.ActivatedRoute }, { type: CookiesService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

class SeoModule {
    static forRoot(config) {
        return {
            ngModule: SeoModule,
            providers: [
                { provide: CookiesService, useClass: config.server8Service }
            ],
        };
    }
}
SeoModule.ɵfac = function SeoModule_Factory(t) { return new (t || SeoModule)(); };
SeoModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SeoModule });
SeoModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, HttpClientModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeoModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [CommonModule, HttpClientModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SeoModule, { imports: function () { return [CommonModule, HttpClientModule]; } }); })();

class PrebootService {
    constructor(appRef, platformId, 
    //private uiHelper: UiHelperService,
    zone) {
        this.appRef = appRef;
        this.platformId = platformId;
        this.zone = zone;
        this.transitionComplete = new BehaviorSubject(false);
        this.isBrowser = isPlatformBrowser(platformId);
        if (this.isBrowser) {
            this.appRef.isStable.pipe(filter(stable => stable), take(1)).subscribe(() => {
                this.isStable = true;
                console.log('preboot service stable');
                this.transitionToClient();
            });
        }
    }
    transitionToClient() {
        if (this.isComplete) {
            return;
        }
        console.log('transition server to client');
        this.transitionComplete.next(true);
        this.isComplete = true;
    }
    forceTransitionComplete(delay) {
        if (!this.isBrowser) {
            return;
        }
        if (!delay || isNaN(Number(delay))) {
            this.transitionToClient();
            return;
        }
        this.zone.runOutsideAngular(() => {
            setTimeout(() => {
                this.zone.run(() => {
                    console.log('force complete');
                    this.transitionToClient();
                });
            }, delay);
        });
    }
}
PrebootService.ɵfac = function PrebootService_Factory(t) { return new (t || PrebootService)(ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
PrebootService.ɵprov = i0.ɵɵdefineInjectable({ factory: function PrebootService_Factory() { return new PrebootService(i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(i0.NgZone)); }, token: PrebootService, providedIn: "root" });
PrebootService.ctorParameters = () => [
    { type: ApplicationRef },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PrebootService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.ApplicationRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc0.NgZone }]; }, null); })();

function querySelectorAllWatcher(element, selector, callback) {
    // Initialize results with current nodes.
    const result = Array.prototype.slice.call(element.querySelectorAll(selector));
    // Create observer instance.
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            Array.prototype.forEach.call(mutation.addedNodes, (node) => {
                if (node.nodeType === Node.ELEMENT_NODE && node.matches(selector)) {
                    result.push(node);
                    callback(node);
                }
            });
        });
    });
    // Set up observer.
    observer.observe(element, { childList: true, subtree: true });
    return {
        resultsList: result,
        unsubscribe: () => observer.disconnect(),
    };
}class EXCO_Client {
    constructor() {
        this._PLACEMENTS_WINDOW_PROPERTY = 'excoPlacements';
        this.excoPlacements = window[this._PLACEMENTS_WINDOW_PROPERTY] =
            window[this._PLACEMENTS_WINDOW_PROPERTY] || [];
    }
    publish(iframe, action, data) {
        try {
            return iframe.contentWindow.pbPubsub.publish(action, data);
        }
        catch (error) {
            console.error(error);
        }
    }
    subscribe(iframe, action, callback) {
        try {
            return iframe.contentWindow.pbPubsub.subscribe(action, callback);
        }
        catch (error) {
            console.error(error);
            return null;
        }
    }
    unsubscribe(iframe, key) {
        try {
            iframe.contentWindow.pbPubsub.unsubscribe(key);
        }
        catch (error) {
            console.error(error);
        }
    }
    mount(placementId, target = document.body) {
        this._clearPlacementsById(placementId);
        this._appendPlacementBlockToTarget(placementId, target);
        this.excoPlacements.push(placementId);
        // temporary fix for push decorator in sdk.js
        if (!this.excoPlacements.includes(placementId)) {
            Array.prototype.push.call(this.excoPlacements, placementId);
        }
        return this._getIframeCreationPromise(placementId, target);
    }
    unmount(placementId) {
        const removeIndex = this.excoPlacements.indexOf(placementId);
        if (removeIndex === -1) {
            throw Error(`palcementId: ${placementId} is not mounted`);
        }
        this.excoPlacements.splice(removeIndex, 1);
        this._clearPlacementsById(placementId);
    }
    _clearPlacementsById(placementId) {
        const placements = document.querySelectorAll(`div[data-placement-id="${placementId}"]`);
        for (let place of placements) {
            place.remove();
        }
    }
    _getIframeCreationPromise(placementId, target = document.body) {
        return new Promise((resolve, reject) => {
            try {
                const watcher = querySelectorAllWatcher(target, `iframe[data-placement-id="${placementId}"]`, (node) => {
                    let innerValue = undefined;
                    Object.defineProperty(node.contentWindow, 'pbPubsub', {
                        set(v) {
                            innerValue = v;
                            watcher.unsubscribe();
                            resolve(node);
                        },
                        get() {
                            return innerValue;
                        },
                    });
                });
            }
            catch (error) {
                reject(error);
            }
        });
    }
    _appendPlacementBlockToTarget(placementId, target) {
        const block = document.createElement('div');
        block.dataset.container = 'exco-placement';
        block.dataset.placementId = placementId;
        try {
            target.appendChild(block);
        }
        catch (error) {
            throw Error(`Can't append block to ${target}`);
        }
    }
}/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}class EXCO_PlacementClient {
    constructor(_placementId) {
        this._placementId = _placementId;
        this._openClient = new EXCO_Client();
    }
    mount(target = document.body) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const iframe = yield this._openClient.mount(this._placementId, target);
                this._placementIFrame = iframe;
            }
            catch (error) {
                return error;
            }
            return this;
        });
    }
    unmount() {
        this._openClient.unmount(this._placementId);
        this._placementIFrame = null;
    }
    publish(action, data) {
        this._openClient.publish(this._placementIFrame, action, data);
    }
    subscribe(action, callback) {
        return this._openClient.subscribe(this._placementIFrame, action, callback);
    }
    unsubscribe(key) {
        this._openClient.unsubscribe(this._placementIFrame, key);
    }
}/**
 * Loads EXCO SDK by tagId
 * @param tagId - tag id from your app.ex.co account
 * @param target - DOM element OR Promise with DOM element to append script
 * @returns - Promise that will be resolved after script append.
 */
function loadSDK(tagId, target = document === null || document === void 0 ? void 0 : document.body) {
    return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
        if (document == null) {
            reject(Error('Documnet is not defined, please - run it in browser context'));
        }
        if ((tagId === null || tagId === void 0 ? void 0 : tagId.length) === 0) {
            reject(Error(`tagId is not valid: ${tagId}`));
        }
        if (target == null) {
            reject(Error('target is not provided'));
        }
        const sdkScript = document.createElement('script');
        sdkScript.type = 'text/javascript';
        sdkScript.src = `https://smart-placements-sdk.ex.co/v1/${tagId}/sdk.js`;
        if (target instanceof Promise || target['then'] !== undefined) {
            // Promise flow
            const targetElement = yield target;
            targetElement.appendChild(sdkScript);
        }
        else {
            // Common flow
            target.appendChild(sdkScript);
        }
        resolve();
    }));
}var Exco_CTA;
(function (Exco_CTA) {
    Exco_CTA["LOADED"] = "pb.cta.loaded";
    Exco_CTA["CLICKED"] = "pb.cta.clicked";
})(Exco_CTA || (Exco_CTA = {}));
var Exco_SDK;
(function (Exco_SDK) {
    Exco_SDK["RENDER"] = "sdk_render";
})(Exco_SDK || (Exco_SDK = {}));
var Exco_Experience;
(function (Exco_Experience) {
    Exco_Experience["LOAD"] = "experience_load";
    Exco_Experience["HIDE"] = "experience_hide";
})(Exco_Experience || (Exco_Experience = {}));
var Exco_Placement;
(function (Exco_Placement) {
    Exco_Placement["LOAD"] = "placement_load";
    Exco_Placement["TRIGGER"] = "trigger_action";
    Exco_Placement["TRIGGER_OPEN"] = "trigger_open";
    Exco_Placement["TRIGGER_CLOSE"] = "trigger_close";
    Exco_Placement["TRIGGER_HIDE"] = "trigger_hide";
})(Exco_Placement || (Exco_Placement = {}));
var Exco_Item;
(function (Exco_Item) {
    Exco_Item["LOAD"] = "pb.item.load";
    Exco_Item["IDLE"] = "pb.item.idle";
    Exco_Item["RENDER"] = "pb.item.render";
    Exco_Item["PROGRESS"] = "pb.item.progress";
    Exco_Item["SHARE"] = "pb.item.share";
    Exco_Item["CHANGE"] = "pb.item.change";
    Exco_Item["SCROLL_TOP_INTO_VIEW"] = "pb.item.scroll-top-into-view";
    Exco_Item["SCROLL_TOP_OUT_OF_VIEW"] = "pb.item.scroll-top-out-of-view";
    Exco_Item["SCROLL_BOTTOM_INTO_VIEW"] = "pb.item.scroll-bottom-into-view";
    Exco_Item["SCROLL_BOTTOM_OUT_OF_VIEW"] = "pb.item.scroll-bottom-out-of-view";
    Exco_Item["POWERED_BY_LINK"] = "pb.item.powered-by-link";
    Exco_Item["PLACEMENT_COMPLETED"] = "pb.placement-unit.completed";
    Exco_Item["PLACEMENT_HEIGHT"] = "pb.placement-unit.height";
})(Exco_Item || (Exco_Item = {}));

class ExcoService {
    constructor(router, httpSvc, document, initializer, prebootSvc) {
        this.router = router;
        this.httpSvc = httpSvc;
        this.document = document;
        this.initializer = initializer;
        this.prebootSvc = prebootSvc;
        this.lastGuid = '';
        this.lastPath = '';
    }
    start() {
        let apiUrl = this.initializer.getAppConfigs().apiUrl;
        this.router.events.pipe(filter(e => e instanceof NavigationEnd), map((e) => e.urlAfterRedirects.split('?')[0])).subscribe((path) => {
            this.httpSvc.get(`${apiUrl}/exco?routePageId=${path}`).subscribe((exco) => {
                this.prebootSvc.transitionComplete.subscribe(v => {
                    if (v) {
                        if (exco === null || exco === void 0 ? void 0 : exco.Result) {
                            this.setExco(exco.Result, path);
                        }
                        else if (this.lastGuid)
                            this.removeLastElement();
                    }
                });
            });
        });
    }
    excoEx(placementId, target) {
        return __awaiter$1(this, void 0, void 0, function* () {
            // await loadSDK('18fb9c43-f34e-46c9-a65d-5bd50a6d4caf');
            yield loadSDK('db853b78-e071-40b7-8f10-08a516d06e28');
            // this.placement = new EXCO_PlacementClient(placementId);
            this.placement = new EXCO_PlacementClient('3dec9e87-cbaf-48fb-8dc5-d35ac1af9d89');
            let element;
            if (target) {
                element = this.document.getElementById(target);
            }
            yield this.placement.mount(element);
            // await placement.subscribe()
        });
    }
    setExco(exco, path) {
        return __awaiter$1(this, void 0, void 0, function* () {
            if (this.lastGuid == exco.Guid || this.lastPath == path) {
                return;
            }
            yield this.removeLastElement();
            yield this.excoEx(exco.Guid, exco.Id);
            this.lastGuid = exco.Guid;
            this.lastPath = path;
        });
    }
    removeLastElement() {
        return __awaiter$1(this, void 0, void 0, function* () {
            if (this.lastGuid) {
                yield this.placement.unmount();
            }
            this.lastGuid = '';
            this.lastPath = '';
        });
    }
}
ExcoService.ɵfac = function ExcoService_Factory(t) { return new (t || ExcoService)(ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(InitializerService), ɵngcc0.ɵɵinject(PrebootService)); };
ExcoService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ExcoService_Factory() { return new ExcoService(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i6.DOCUMENT), i0.ɵɵinject(InitializerService), i0.ɵɵinject(PrebootService)); }, token: ExcoService, providedIn: "root" });
ExcoService.ctorParameters = () => [
    { type: Router },
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: InitializerService },
    { type: PrebootService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ExcoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.Router }, { type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: InitializerService }, { type: PrebootService }]; }, null); })();

class ExcoModule {
    static forRoot(config) {
        return {
            ngModule: ExcoModule,
            providers: [],
        };
    }
}
ExcoModule.ɵfac = function ExcoModule_Factory(t) { return new (t || ExcoModule)(); };
ExcoModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ExcoModule });
ExcoModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, HttpClientModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ExcoModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [CommonModule, HttpClientModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ExcoModule, { imports: function () { return [CommonModule, HttpClientModule]; } }); })();

class IfStableDirective {
    constructor(element, templateRef, viewContainer, prebootSvc) {
        this.element = element;
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.prebootSvc = prebootSvc;
    }
    ngOnInit() {
        this.sub = this.prebootSvc.transitionComplete.subscribe(stable => {
            this.updateView(stable);
        });
    }
    ngOnDestroy() {
        if (this.sub && !this.sub.closed) {
            this.sub.unsubscribe();
        }
    }
    updateView(show) {
        if (show) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
        else {
            this.viewContainer.clear();
        }
    }
}
IfStableDirective.ɵfac = function IfStableDirective_Factory(t) { return new (t || IfStableDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(PrebootService)); };
IfStableDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: IfStableDirective, selectors: [["", "appIfStable", ""]] });
IfStableDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: PrebootService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IfStableDirective, [{
        type: Directive,
        args: [{
                selector: '[appIfStable]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: PrebootService }]; }, null); })();

class PrebootHelperModule {
}
PrebootHelperModule.ɵfac = function PrebootHelperModule_Factory(t) { return new (t || PrebootHelperModule)(); };
PrebootHelperModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PrebootHelperModule });
PrebootHelperModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PrebootHelperModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [IfStableDirective],
                providers: [],
                exports: [IfStableDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PrebootHelperModule, { declarations: [IfStableDirective], exports: [IfStableDirective] }); })();

/*
 * Public API Surface of core-max-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AnalyticsDirective, AnalyticsService, AppLinkDirective, AuthGuard, AuthModule, CookiesService, CoreAuthService, ExcoModule, ExcoService, HttpModule, HttpService, HttpServiceLogInterceptor, IfStableDirective, InitializerModule, InitializerService, JwtModule, JwtService, LogType, LoggerHandlerService, LoggerHandlerServiceAbstract, LoggerHelperService, LoggerListenerService, LoggerService, LoggingModule, MaxCommonModule, MaxDialogConfig, MaxDialogModule, MaxDialogRef, MaxDialogService, PrebootHelperModule, PrebootService, ROLES_TYPE, RoutingHistoryService, RoutingModule, SeoModule, SeoService, ServerClientContextLoader, ServerConfigurationModule, ServerConfigurationService, UiHelperModule, UiHelperService, UniversalInterceptorService, UniversalModule, WrongUrlInterceptor, isNullOrUndefined, init_app$1 as ɵa, init_app as ɵb, CONFIG_URL as ɵc, JWT_KEY_NAME as ɵd, AuthHandlerService as ɵe, MaxDialogComponent as ɵf, MaxDialogDirective as ɵg, LOGS_URL as ɵh };

//# sourceMappingURL=core-max-lib.js.map